"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on Tue Jul 17 2018
*/

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var CleaningSettings_1 = require("./CleaningSettings");

var FamilySettings_1 = require("./FamilySettings");

var FinalPriceDefaultEnum_1 = require("./FinalPriceDefaultEnum");
/**
 * This object represents configurations for settings prices, data cleaning, alerts and price sesitivity.
 * This configuration is one unique for whole project.
 *
 * @author RV
 */


var GlobalSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(GlobalSettings, _DomainObject_1$Domai);

  /**
   * Constructs globalSettings instance.
   *
   * @param id the internal id of globalSettings
   * @param familySettings
   * @param cleaningSettings
   * @param finalPriceDefault default settings for choosing final price
   * @param impactHistoryLength maximal history length of historical/forecasted sales for all impact index calculation
   * @param sensitivityDefaultId default price sensitivity group
   * @param missingCompetitorPrice No. of weeks for missing competitor prices report
   * @param priceStickerLimit
   */
  function GlobalSettings(id, familySettings, cleaningSettings, finalPriceDefault, impactHistoryLength, sensitivityDefaultId, missingCompetitorPrice, priceStickerLimit) {
    var _this;

    _classCallCheck(this, GlobalSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GlobalSettings).call(this));
    _this.id = id;
    _this.familySettings = familySettings;
    _this.cleaningSettings = cleaningSettings;
    _this.finalPriceDefault = finalPriceDefault;
    _this.impactHistoryLength = impactHistoryLength;
    _this.sensitivityDefaultId = sensitivityDefaultId;
    _this.missingCompetitorPrice = missingCompetitorPrice;
    _this.priceStickerLimit = priceStickerLimit;
    return _this;
  }

  return GlobalSettings;
}(DomainObject_1.DomainObject);

exports.GlobalSettings = GlobalSettings; // tslint:disable-next-line:member-ordering

GlobalSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(GlobalSettings.name);
  return {
    id: builder.id('id'),
    familySettings: builder.obj('familySettings', FamilySettings_1.FamilySettings.schema, function (mat) {
      return new FamilySettings_1.FamilySettings(mat.leaderMaxHistoryLength, mat.leaderFrequencyRecalculation);
    }),
    cleaningSettings: builder.obj('cleaningSettings', CleaningSettings_1.CleaningSettings.schema, function (mat) {
      return new CleaningSettings_1.CleaningSettings(mat.referencePriceChangeIndex, mat.competitorReferencePriceChangeIndex, mat.internalVsCompetitorReferencePriceChangeIndex, mat.extremePriceChangeIndex, mat.agencyResearchWeight, mat.webscrapingWeight, mat.promoPriceDetectionSettings, mat.outlierPriceDetectionSettings);
    }),
    impactHistoryLength: builder.num('impactHistoryLength'),
    finalPriceDefault: builder.senum('finalPriceDefault', FinalPriceDefaultEnum_1.FinalPriceDefaultEnum, CodebookLookupSequence_1.CodebookLookupSequence.FinalPriceDefault),
    sensitivityDefaultId: builder.lookup('sensitivityDefaultId', CodebookLookupSequence_1.CodebookLookupSequence.ProductSensitivity),
    missingCompetitorPrice: builder.num('missingCompetitorPrice'),
    priceStickerLimit: builder.num('priceStickerLimit')
  };
}();